import Input from "../../../common/Input";

const Address = ({
	handleChange,
	values,
	touched,
	errors,
	setFieldTouched,
	isEdit,
	handleEditIconClick,
	handleBlur,
	editingField,
	isDisabled,
}) => {
	// const { handleChange, values, touched, errors, setFieldTouched } = formik;

	return (
		<div className="mb-3">
			<h2 className="text-black-lose text-[13px] font-medium mb-2">Address</h2>
			<div className="grid grid-cols-12 gap-[8px]">
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Premises No./ Floor*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.premisesNo"
						id="address.premisesNo"
						value={values?.address?.premisesNo}
						onChange={handleChange}
						isError={
							touched?.address?.premisesNo &&
							Boolean(errors?.address?.premisesNo)
						}
						errorMessage={errors?.address?.premisesNo}
						disabled={isDisabled && editingField !== "address.premisesNo"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.premisesNo") : "")}
						onEditClick={() => handleEditIconClick("address.premisesNo")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Premises Name*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.premisesName"
						id="address.premisesName"
						value={values?.address?.premisesName}
						onChange={handleChange}
						isError={
							touched?.address?.premisesName &&
							Boolean(errors?.address?.premisesName)
						}
						errorMessage={errors?.address?.premisesName}
						disabled={isDisabled && editingField !== "address.premisesName"}
						showEditIcon={isEdit}
						onBlur={() =>
							handleBlur ? handleBlur("address.premisesName") : ""
						}
						onEditClick={() => handleEditIconClick("address.premisesName")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Landmark"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.landmark"
						id="address.landmark"
						value={values?.address?.landmark}
						onChange={handleChange}
						disabled={isDisabled && editingField !== "address.landmark"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.landmark") : "")}
						onEditClick={() => handleEditIconClick("address.landmark")}
						disabledClass="bg-primary-50 border-primary-50 "
						// isError={
						//   touched?.address?.landmark && Boolean(errors?.address?.landmark)
						// }
						// errorMessage={errors?.address?.landmark}
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Area/Road*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.areaRoad"
						id="address.areaRoad"
						value={values?.address?.areaRoad}
						onChange={handleChange}
						isError={
							touched?.address?.areaRoad && Boolean(errors?.address?.areaRoad)
						}
						errorMessage={errors?.address?.areaRoad}
						disabled={isDisabled && editingField !== "address.areaRoad"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.areaRoad") : "")}
						onEditClick={() => handleEditIconClick("address.areaRoad")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="City*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.city"
						id="address.city"
						value={values?.address?.city}
						onChange={handleChange}
						isError={touched?.address?.city && Boolean(errors?.address?.city)}
						errorMessage={errors?.address?.city}
						disabled={isDisabled && editingField !== "address.city"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.city") : "")}
						onEditClick={() => handleEditIconClick("address.city")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Pin Code*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.pinCode"
						id="address.pinCode"
						value={values?.address?.pinCode}
						onChange={(e) => {
							handleChange(e);
							setFieldTouched("address.pinCode", true, false);
						}}
						isError={
							touched?.address?.pinCode && Boolean(errors?.address?.pinCode)
						}
						errorMessage={errors?.address?.pinCode}
						disabled={isDisabled && editingField !== "address.pinCode"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.pinCode") : "")}
						onEditClick={() => handleEditIconClick("address.pinCode")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-6">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="State*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.state"
						id="address.state"
						value={values?.address?.state}
						onChange={handleChange}
						isError={touched?.address?.state && Boolean(errors?.address?.state)}
						errorMessage={errors?.address?.state}
						disabled={isDisabled && editingField !== "address.state"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.state") : "")}
						onEditClick={() => handleEditIconClick("address.state")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-6">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Phone Number 2"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="address.phoneNumber"
						id="address.phoneNumber"
						value={values?.address?.phoneNumber}
						onChange={(e) => {
							handleChange(e);
							setFieldTouched("address.phoneNumber", true, false); // Mark the field as touched
						}}
						isError={
							touched?.address?.phoneNumber &&
							Boolean(errors?.address?.phoneNumber)
						}
						errorMessage={errors?.address?.phoneNumber}
						disabled={isDisabled && editingField !== "address.phoneNumber"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("address.phoneNumber") : "")}
						onEditClick={() => handleEditIconClick("address.phoneNumber")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
			</div>
		</div>
	);
};

export default Address;
